export const prefix = "@ttribo:";

export const COLLECTION = {
  AVAILABILITY_OF_SCHEDULES: `${prefix}availablity_of_schedules`,
  STOPWATCH_GOAL_TIME: `${prefix}stopwatch_goal_time`,
  STOPWATCH_TIME: `${prefix}stopwatch_time`,
  STOPWATCH_REGRESSIVE: `${prefix}stopwatch_regressive`,
  STOPWATCH_GOAL_ID: `${prefix}stopwatch_goal_id`,
};
